(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/actions.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/actions.js');
"use strict";

const _excluded = ["pix"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }

svs.challenge.actions.SELECT_ALTERNATIVE = 'SELECT_ALTERNATIVE';
svs.challenge.actions.SELECT_BET_AMOUNT = 'SELECT_BET_AMOUNT';
svs.challenge.actions.CLEAR_COUPON = 'CLEAR_COUPON';
svs.challenge.actions.LOAD_LOCALSTORAGE = 'LOAD_LOCALSTORAGE';
svs.challenge.actions.URL_PARAMETERS = 'URL_PARAMETERS';
svs.challenge.actions.LOAD_SETTINGS_LOCALSTORAGE = 'LOAD_SETTINGS_LOCALSTORAGE';
svs.challenge.actions.LOGIN = 'LOGIN';
svs.challenge.actions.LOGOUT = 'LOGOUT';
svs.challenge.actions.RECEIVE_ACCOUNT_BALANCE = 'RECEIVE_ACCOUNT_BALANCE';
svs.challenge.actions.RECEIVE_ACCOUNT_BALANCE_SUCCESS = 'RECEIVE_ACCOUNT_BALANCE_SUCCESS';
svs.challenge.actions.OPEN_TIPSINFO = 'OPEN_TIPSINFO';
svs.challenge.actions.CLOSE_TIPSINFO = 'CLOSE_TIPSINFO';
svs.challenge.actions.SET_TIPSINFO = 'SET_TIPSINFO';
svs.challenge.actions.OPEN_SPELGUIDE = 'OPEN_SPELGUIDE';
svs.challenge.actions.CLOSE_SPELGUIDE = 'CLOSE_SPELGUIDE';
svs.challenge.actions.OPEN_XPERTEN = 'OPEN_XPERTEN';
svs.challenge.actions.CLOSE_XPERTEN = 'CLOSE_XPERTEN';
svs.challenge.actions.FETCH_XPERTEN_SUCCESS = 'FETCH_XPERTEN_SUCCESS';
svs.challenge.actions.CLEAR_BASE_ROW = 'CLEAR_BASE_ROW';
svs.challenge.actions.START_EDIT_BASE_ROW = 'START_EDIT_BASE_ROW';
svs.challenge.actions.SELECT_XPERT = 'SELECT_XPERT';
svs.challenge.actions.CLOSE_ACTIONBAR = 'CLOSE_ACTIONBAR';
svs.challenge.actions.PAYMENT_INITIATE = 'PAYMENT_INITIATE';
svs.challenge.actions.PAYMENT_CONFIRM = 'PAYMENT_CONFIRM';
svs.challenge.actions.PAYMENT_SUCCESS = 'PAYMENT_SUCCESS';
svs.challenge.actions.PAYMENT_FAILED = 'PAYMENT_FAILED';
svs.challenge.actions.PAYMENT_CANCEL = 'PAYMENT_CANCEL';
svs.challenge.actions.TOGGLE_OVERVIEW = 'TOGGLE_OVERVIEW';
svs.challenge.actions.CLOSE_OVERVIEW = 'CLOSE_OVERVIEW';
svs.challenge.actions.selectAlternative = (drawNumber, rowNumber, outcomeNumber) => (dispatch, getState) => {
  const coupon = svs.challenge.helpers.getCouponByDrawNumber(getState(), drawNumber);
  let isChecking = false;
  coupon.drawEvents.forEach((drawEvent, index) => {
    if (index === rowNumber) {
      drawEvent.forEach((alternative, index) => {
        if (index === outcomeNumber) {
          if (!alternative) {
            isChecking = true;
          }
        }
      });
    }
  });
  dispatch({
    drawNumber,
    isChecking,
    outcomeNumber,
    rowNumber,
    type: svs.challenge.actions.SELECT_ALTERNATIVE
  });
};
svs.challenge.actions.selectBetAmount = (drawNumber, chosenBetPrice) => ({
  chosenBetPrice,
  drawNumber,
  type: svs.challenge.actions.SELECT_BET_AMOUNT
});
svs.challenge.actions.clearCoupon = drawNumber => ({
  drawNumber,
  type: svs.challenge.actions.CLEAR_COUPON
});
svs.challenge.actions.loadFromLocalStorage = data => ({
  data,
  type: svs.challenge.actions.LOAD_LOCALSTORAGE
});
svs.challenge.actions.loadFromUrlParameters = (querySigns, drawNumber) => ({
  querySigns,
  drawNumber,
  type: svs.challenge.actions.URL_PARAMETERS
});
svs.challenge.actions.loadSettingsFromLocalStorage = data => ({
  data,
  type: svs.challenge.actions.LOAD_SETTINGS_LOCALSTORAGE
});
svs.challenge.actions.login = () => ({
  type: svs.challenge.actions.LOGIN
});
svs.challenge.actions.logout = () => ({
  type: svs.challenge.actions.LOGOUT
});
svs.challenge.actions.receiveAccountBalance = () => dispatch => {
  svs.components.account_balance.get(false, accountBalance => {
    dispatch(svs.challenge.actions.receiveAccountBalanceSuccess(accountBalance));
  });
};
svs.challenge.actions.receiveAccountBalanceSuccess = accountBalance => ({
  accountBalance,
  type: svs.challenge.actions.RECEIVE_ACCOUNT_BALANCE_SUCCESS
});
svs.challenge.actions.openXperten = () => ({
  type: svs.challenge.actions.OPEN_XPERTEN
});
svs.challenge.actions.closeXperten = () => ({
  type: svs.challenge.actions.CLOSE_XPERTEN
});
svs.challenge.actions.openSpelguide = () => ({
  type: svs.challenge.actions.OPEN_SPELGUIDE
});
svs.challenge.actions.closeSpelguide = () => ({
  type: svs.challenge.actions.CLOSE_SPELGUIDE
});
svs.challenge.actions.openTipsinfo = () => ({
  type: svs.challenge.actions.OPEN_TIPSINFO
});
svs.challenge.actions.closeTipsinfo = () => ({
  type: svs.challenge.actions.CLOSE_TIPSINFO
});
svs.challenge.actions.setTipsinfo = changedInfo => {
  const newSettings = _objectSpread(_objectSpread({}, svs.challenge.store.getState().settings), changedInfo);
  svs.components.Storage.browser.set(svs.challenge.constants.LOCAL_STORAGE_SETTINGS_NAME, svs.challenge.constants.LOCAL_STORAGE_DOMAIN, {
    settings: _objectSpread({}, newSettings)
  }, svs.components.Storage.constants.EXPIRES_1WEEK);
  return {
    settings: _objectSpread({}, newSettings),
    type: svs.challenge.actions.SET_TIPSINFO
  };
};
svs.challenge.actions.closeActionbar = drawNumber => ({
  drawNumber,
  type: svs.challenge.actions.CLOSE_ACTIONBAR
});
const getSizeFromBoardData = boardData => {
  let size = 1;
  for (let i = 0; i < boardData.length; ++i) {
    size *= boardData[i].length;
  }
  return size;
};
const createPixWager = (data, drawNumber) => {
  const pix = data.pix,
    restData = _objectWithoutProperties(data, _excluded);
  const boardData = pix.events.map(event => {
    const outcomes = event.outcomes;
    return outcomes.map(outcome => outcome.value).join('');
  });
  return _objectSpread({
    crc: 0,
    marketInfo: 0,
    bagType: 0,
    bets: [{
      productId: 'TMIX',
      drawNum: drawNumber,
      betAmountSalesGroup1: '0,00',
      betAmountSalesGroup2: '0,00',
      rowPriceMulti: 1,
      betProperties: [],
      game1X2Boards: [{
        systemType: ['MSYS'],
        systemNum: 1,
        numSelections: getSizeFromBoardData(boardData),
        rowPriceMulti: 1,
        boardData,
        boardProps: ['WEIGHTEDQP']
      }]
    }]
  }, restData);
};
const showErrorDialog = () => svs.components.dialog.api.add(new svs.components.dialog.Confirm({
  actions: [{
    title: 'Okej'
  }],
  branding: svs.components.dialog.branding.SPORT,
  icon: 'help-2',
  title: "Det g\xE5r tyv\xE4rr inte att spela p\xE5 PIX! just nu"
}));
const getSelectedOutcomes = coupon => {
  const events = [];
  const numberOfDrawEvents = coupon.drawEvents.length;
  const baseRow = coupon.baseRow;
  for (let i = 1; i <= numberOfDrawEvents; i++) {
    if (baseRow[i]) {
      const event = {};
      event.eventNumber = i;
      event.outcomes = [];
      if (baseRow[i][1]) {
        event.outcomes.push({
          value: '1'
        });
      }
      if (baseRow[i][2]) {
        event.outcomes.push({
          value: 'X'
        });
      }
      if (baseRow[i][4]) {
        event.outcomes.push({
          value: '2'
        });
      }
      events.push(event);
    }
  }
  return events;
};
svs.challenge.actions.generateXpert = (drawNumber, selectedXpert, useBaseRow) => (dispatch, getState) => {
  const _svs$challenge$helper = svs.challenge.helpers.getDrawByDrawNumber(drawNumber, getState()),
    rowPrice = _svs$challenge$helper.rowPrice;
  const systemSize = parseInt(selectedXpert / parseFloat(rowPrice), 10);
  let events = [];
  if (useBaseRow) {
    const coupon = svs.challenge.helpers.getCouponByDrawNumber(getState(), drawNumber);
    events = getSelectedOutcomes(coupon);
  } else {
    dispatch({
      drawNumber,
      type: svs.challenge.actions.CLEAR_BASE_ROW
    });
  }
  const path = '/wager/1/challenge/pix';
  const params = new URLSearchParams();
  params.append('flavour', 'SafeChallenge');
  params.append('systemType', 'MSys');
  params.append('systemNumberMapping', systemSize);
  params.append('drawNumber', drawNumber);
  svs.core.jupiter.post({
    path: "".concat(path, "?").concat(params.toString()),
    data: {
      events
    }
  }, data => {
    if (!data.error) {
      dispatch({
        drawNumber,
        payload: createPixWager(data, drawNumber),
        type: svs.challenge.actions.FETCH_XPERTEN_SUCCESS,
        xpert: selectedXpert
      });
    }
  }, () => showErrorDialog);
};
svs.challenge.actions.startEditBaseRow = (xpert, drawNumber) => ({
  drawNumber,
  type: svs.challenge.actions.START_EDIT_BASE_ROW,
  xpert
});
svs.challenge.actions.initiatePayment = () => ({
  type: svs.challenge.actions.PAYMENT_INITIATE
});
svs.challenge.actions.confirmPayment = () => ({
  type: svs.challenge.actions.PAYMENT_CONFIRM
});
svs.challenge.actions.paymentSuccess = () => ({
  type: svs.challenge.actions.PAYMENT_SUCCESS
});
svs.challenge.actions.paymentFailed = () => ({
  type: svs.challenge.actions.PAYMENT_FAILED
});
svs.challenge.actions.cancelPayment = () => ({
  type: svs.challenge.actions.PAYMENT_CANCEL
});
svs.challenge.actions.toggleOverview = () => ({
  type: svs.challenge.actions.TOGGLE_OVERVIEW
});
svs.challenge.actions.closeOverview = () => ({
  type: svs.challenge.actions.CLOSE_OVERVIEW
});

 })(window);